import { createRouter, createWebHistory } from 'vue-router'
import HomeVilla from '../pages/HomeVilla.vue'
import ChaletDetail from '../pages/ChaletDetail.vue'
import BookingForm from '../pages/BookingForm.vue'
import BookingConfirmation from '../pages/BookingConfirmation.vue'
import AdminDashboard from '@/components/admin/AdminDashboard.vue'
import NotFound from '../pages/NotFound.vue'

const routes = [
  { path: '/', component: HomeVilla },
  { path: '/contactus', component: ChaletDetail },
  { path: '/book', component: BookingForm },
  { path: '/booking-confirmation', component: BookingConfirmation },
  { path: '/Admin-dashboard', component: AdminDashboard},
  { path: '/:catchAll(.*)', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
